var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-slider" },
    [
      _c("div", { staticClass: "carousel-slider--slides" }, [
        _c(
          "div",
          { staticClass: "carousel-slider--rail", style: _vm.wrapStyles },
          _vm._l(_vm.items, function(item, itemIdx) {
            return _c(
              "div",
              {
                ref: "item",
                refInFor: true,
                staticClass: "carousel-slider--item grid--col",
                style: _vm.itemStyles
              },
              [
                _vm._t("item", null, {
                  item: item,
                  isActive: itemIdx === _vm.state.idx,
                  itemIdx: itemIdx
                })
              ],
              2
            )
          })
        )
      ]),
      _vm._v(" "),
      _vm._t("arrow-nav", null, {
        numItems: _vm.items.length,
        activeIdx: _vm.state.idx,
        changeHandler: _vm.onRequestChange
      }),
      _vm._v(" "),
      _vm._t("bullet-nav", null, {
        numItems: _vm.items.length,
        activeIdx: _vm.state.idx,
        changeHandler: _vm.onRequestChange
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-737b72fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-737b72fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/ui/carousel/carousel-slider/index.vue
// module id = 436
// module chunks = 5